<template>
  <form-autocomplete :label="extractedLabel"
                     :data="search"
                     v-model="val"
                     :disabled="disabled"
                     :selected="selected">
  </form-autocomplete>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: null
      },
      value: null,
      name: {
        type: null,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        val: '',
        extractedLabel: this.label || this.$t('interface.chooseSource')
      }
    },
    methods: {
      search(q) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('Reference/getCounterparts', q).then(data => {
            resolve(data.map((counterpart) => {
              return {key: counterpart.id, value: counterpart.name}
            }))
          }).catch(error => reject(error))
        })
      }
    },
    computed: {
      selected() {
        if (this.value && this.name) {
          return {
            key: this.value,
            value: this.name
          }
        } else return false
      }
    },
    watch: {
      val(value) {
        this.$emit('input', value)
      }
    }
  }
</script>